export const menuIcrDictionarySelectbuttons = [
  { label: 'ICR dictionary', value: 'ICR dictionary' },
];
